import { render } from "./ProductPanelView.vue?vue&type=template&id=c209658e"
import script from "./ProductPanelView.vue?vue&type=script&lang=js"
export * from "./ProductPanelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__